import { graphql, type HeadFC, type PageProps } from 'gatsby';
import type { FC } from 'react';
import Markdown from 'react-markdown';
import type { SEOEntity } from '../@types/gql/seo';
import TermsLayout from '../components/container/terms-layout';
import SEOComponent from '../components/shared/seo';

const Page: FC<
  PageProps<{ strapiOrderAndDeliveryTerm: { Content: string } }>
> = ({ data }) => {
  return (
    <TermsLayout currentPage="order-and-delivery-terms">
      <Markdown className="rich-text-view leading-loose">
        {data.strapiOrderAndDeliveryTerm.Content}
      </Markdown>
    </TermsLayout>
  );
};

export default Page;

export const Head: HeadFC<{
  strapiOrderAndDeliveryTerm?: { seo?: SEOEntity };
}> = ({ data }) => <SEOComponent seo={data.strapiOrderAndDeliveryTerm?.seo} />;

export const query = graphql`
  query OrderAndDeliveryTermsQuery {
    strapiOrderAndDeliveryTerm {
      Content
      seo {
        ...SEOFragment
      }
    }
  }
`;
